import { render, staticRenderFns } from "./DrUserList.vue?vue&type=template&id=acec75ce&"
import script from "./DrUserList.vue?vue&type=script&lang=js&"
export * from "./DrUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports